"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/LearningPath/components/Li.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Image_template = require("../../../../components/Image/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Image_tag = marko_loadTag(Image_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    Row_template = require("../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_attrs0 = {
        "class": "d-flex align-items-center"
      },
    marko_attrs1 = {
        "class": "theme-bg border text-center d-flex align-items-center",
        style: "width:40px;height:40px;border-radius:50%;margin-left:-4.4em;margin-right:1.5em"
      },
    marko_attrs2 = {
        "class": "w-100 font-medium-3"
      },
    marko_attrs3 = {
        "class": "col-lg-3"
      },
    marko_attrs4 = {
        "class": "col"
      },
    marko_attrs5 = {
        "class": "course-header mb-2"
      },
    marko_attrs6 = {
        "class": "theme-color float-right"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("433bd5"),
    marko_node0 = marko_createElement("div", {
        "class": "course-description"
      }, "11", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("p", null, null, null, 1)
        .t("Cheesecake cotton candy bonbon muffin cupcake tiramisu croissant. Tootsie roll sweet candy bear claw chupa chups lollipop toffee. Macaroon donut liquorice powder.");

function render(input, out, __component, component, state) {
  var data = input;

  out.be("li", marko_attrs0, "0", component);

  out.e("div", null, "1", component, 1)
    .e("div", marko_attrs1, "2", component, 1)
      .e("div", marko_attrs2, "3", component, 1)
        .t(input.number, component);

  Row_tag({
      class: "p-2",
      renderBody: function(out) {
        out.be("div", marko_attrs3, "5", component);

        Image_tag({
            alt: "Image",
            class: "img-fluid rounded",
            src: input.image
          }, out, __component, "6");

        out.ee();

        out.be("div", marko_attrs4, "7", component);

        out.be("div", marko_attrs5, "8", component);

        out.e("strong", marko_attrs6, "9", component, 1)
          .t(input.time, component);

        route_link_tag({
            href: "/course/:id",
            class: "font-medium-3",
            renderBody: function(out) {
              out.t(input.title, component);
            }
          }, out, __component, "10");

        out.ee();

        out.n(marko_node0, component);

        out.ee();
      }
    }, out, __component, "4");

  out.ee();
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
